/**
 * Vuex
 *
 * set 和 toggle 统一处理
 */
export const set = property => (state, payload) => (state[property] = payload)
export const toggle = property => state => (state[property] = !state[property])
export const setData = property => state => (state.property = property)
